import {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UPDATE_DESIGN_OPTIONS} from '~/common/fabric/reducers/fabricDesign/constants';
import {
  selectPremiumFeaturesWarning,
  selectShowCanvasTooltip,
} from '~/common/fabric/reducers/fabricDesign/selectors';
import {EventCreateContext} from '../EventCreateContext';

export const useDesignCanvas = () => {
  const dispatch = useDispatch();
  const {canvas, setCardDesignRef} = useContext(EventCreateContext);
  const designContainerRef = useRef();
  const premiumFeaturesWarning = useSelector(selectPremiumFeaturesWarning);
  const showCanvasTooltip = useSelector(selectShowCanvasTooltip);
  const [showCanvasTooltipState, setShowCanvasTooltipState] = useState(false);

  useEffect(() => {
    if (designContainerRef?.current) {
      setCardDesignRef(designContainerRef);
    }
  }, [setCardDesignRef]);

  useEffect(() => {
    const onSelectionEvent = (value) => {
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {editingMobile: value},
      });
    };

    const handleSelectionCreatedOrUpdated = () => onSelectionEvent(true);
    const handleSelectionCleared = () => onSelectionEvent(false);

    canvas?.on('selection:created', handleSelectionCreatedOrUpdated);
    canvas?.on('selection:updated', handleSelectionCreatedOrUpdated);
    canvas?.on('selection:cleared', handleSelectionCleared);

    return () => {
      canvas?.off('selection:created', handleSelectionCreatedOrUpdated);
      canvas?.off('selection:updated', handleSelectionCreatedOrUpdated);
      canvas?.off('selection:cleared', handleSelectionCleared);
    };
  }, [canvas, dispatch]);

  useEffect(() => {
    setShowCanvasTooltipState(showCanvasTooltip);
  }, [showCanvasTooltip]);

  const dismissPremiumFeaturesWarning = useCallback(() => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {
        premiumFeaturesWarning: false,
        ignorePremiumWarning: true,
      },
    });
  }, [dispatch]);

  return {
    designContainerRef,
    showCanvasTooltipState,
    dismissPremiumFeaturesWarning,
    premiumFeaturesWarning,
  };
};
